export default __webpack_public_path__ + "static/media/cupcake-2.74dad30d.jpeg";